import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { SessionService } from 'src/app/auth/session/session.service';
import { CommandRequest, DeviceCommandSchedulerService } from '../services/device-command-scheduler.service';

@Component({
  selector: 'command-request-modal',
  templateUrl: './command-request-modal.component.html',
  styleUrls: ['./command-request-modal.component.scss']
})

export class CommandRequestModalComponent implements OnInit {
  @Output() refreshPage: EventEmitter<any> = new EventEmitter();

  description: string = '';
  serialNumbers: string = '';
  commands: string[] = ["Check In", "Wake", "Sync Settings", "Reboot", "Force Update"];
  selectedCommand: string;

  constructor(
    private activeModal: NgbActiveModal,
    private deviceCommandService: DeviceCommandSchedulerService,
    private toastr: ToastrService,
    private sessionService: SessionService,
  ) { }

  ngOnInit() {
  }

  cancel() {
    this.refreshPage.emit();
    this.activeModal.close();
  }

  async submit() {
    if (!this.serialNumbers.length) {
      this.toastr.warning(`Serial numbers are required.`);
      return;
    }

    if (this.selectedCommand == undefined) {
      this.toastr.warning(`Command is required.`);
      return;
    }

    try {
      let request: CommandRequest = {
        command: this.getCommandName(this.selectedCommand),
        serialNumbers: this.serialNumbers.split(',').map(value => value.trim()),
        requesterName: this.getUserName(),
        description: this.description
      };
      await this.deviceCommandService.submitCommandRequest(request);
    } catch (e) {
      this.toastr.error(`Failed to submit the new request, please try again.`);
      return;
    }

    this.toastr.success(`Successfully issued command request.`);
    this.refreshPage.emit();
    this.activeModal.close();
  }

  private getUserName(): string {
    return this.sessionService.getCurrentSession().name;
  }
  private getCommandName(command: string): string {
    switch (command) {
      case 'Check In':
        return 'checkIn'
      case 'Wake':
        return 'wake'
      case 'Sync Settings':
        return 'settingsUpdate'
      case 'Reboot':
        return 'reboot'
      case 'Force Update':
        return 'forceUpdate'
      default:
        return undefined;
    }
  }
}
